export default function Info() {
    return (
        <div id="infoContainer">
            <h2>Josh Eddie</h2>
            <p className="title">Software Engineer</p>
            <a href="https://www.linkedin.com/in/josh-eddie/" target='_blank'>LinkedIn</a>
            <a href="https://github.com/JoshEddie" target='_blank'>GitHub</a>
        </div>
    )
}